<template>
  <svg fill="none" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 12H19" v-bind="$attrs" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 5L19 12L12 19" v-bind="$attrs" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'arrow-right'
}
</script>



// WEBPACK FOOTER //
// src/ui/icon/ArrowRight.vue